import "babel-polyfill";
import "es6-promise/auto";
import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import Router from "vue-router";
//import VueTelInput from 'vue-tel-input';
import BootstrapVue from "bootstrap-vue";
import Fitty from "vue-fitty";
import VueTheMask from "vue-the-mask";
import VueClipboard from "vue-clipboard2";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import './assets/scss/style.scss';

import config from "./config";

//Helpers
import * as helpers from "./helpers.js";
import * as auth from "./auth.js";
import * as validate from "./validate.js";
import * as formatter from "./formatter.js";
import * as authService from "./msal";
import * as log from "./log";

import LogRocket from "logrocket";
LogRocket.init("wrlhlc/dashtech", {
	network: {
		requestSanitizer: request => {
			// if the url contains 'identity'
			if (request.url.toLowerCase().indexOf('identity') !== -1) {
				// scrub out the body
				request.body = null;
			}

			// scrub header value from request
			if (request.headers['Authorization']) {
				request.headers['Authorization'] = '';
			}

			// make sure you return the modified request
			return request;
		},
		responseSanitizer: response => {
			// scrub accessToken value from response
			if (response.accessToken) {
				response.accessToken = ''
			}

			// scrub refreshToken value from response
			if (response.refreshToken) {
				response.refreshToken = ''
			}

			// make sure you return the modified response
			return response
		}
	},
});

const helperPlugin = {
	install() {
		Vue.helpers = helpers;
		Vue.prototype.$helpers = helpers;
		Vue.auth = auth;
		Vue.prototype.$auth = auth;
		Vue.validate = validate;
		Vue.prototype.$validate = validate;
		Vue.formatter = formatter;
		Vue.prototype.$formatter = formatter;
		Vue.authService = authService;
		Vue.prototype.$authService = authService;
		Vue.log = log.log;
		Vue.prototype.$log = log.log;
		Vue.error = log.error;
		Vue.prototype.$error = log.error;
	},
};
Vue.use(helperPlugin);

//Vuex
Vue.use(Vuex);
import { store } from "./store.js";

//Typeahead
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
Vue.component("vue-bootstrap-typeahead", VueBootstrapTypeahead);

//Font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faArrowLeft,
	faArrowRight,
	faCheckCircle as fasCheckCircle,
	faTrashAlt as fasTrashAlt,
	faCheck,
	faPlus,
	faSearch,
	faUndoAlt,
	faChevronRight,
	faChevronLeft,
	faPaperPlane,
	faTimes,
	faAngleDown,
	faAngleUp,
	faEdit,
	faChartBar,
	faPoll,
	faUsers,
	faCogs
} from "@fortawesome/free-solid-svg-icons";
import {
	faCheckCircle as farCheckCircle,
	faTrashAlt as farTrashAlt,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
	faArrowLeft,
	faArrowRight,
	fasCheckCircle,
	farCheckCircle,
	faPlus,
	faSearch,
	faUndoAlt,
	faChevronRight,
	faChevronLeft,
	faPaperPlane,
	faCheck,
	fasTrashAlt,
	farTrashAlt,
	faTimes,
	faAngleDown,
	faAngleUp,
	faEdit,
	faChartBar,
	faPoll,
	faUsers,
	faCogs
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

//Bootstrap Icons
import { BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
Vue.use(BootstrapVueIcons);

//import custom style
import "@/assets/css/style.css";

//import typeface
import "typeface-poppins";

//Interceptors
import interceptors from "./interceptors.js";
interceptors();

//Global Components
import BaseMessageBlock from "@/components/global/BaseMessageBlock.vue";
Vue.component("BaseMessageBlock", BaseMessageBlock);
import LoadingIndicator from "@/components/global/LoadingIndicator.vue";
Vue.component("LoadingIndicator", LoadingIndicator);

Vue.use(VueTheMask);
Vue.use(BootstrapVue);
Vue.use(VueClipboard);
Vue.use(Fitty);

//Routes
import routes from "@/routes.js";
Vue.use(Router);
let router = new Router({
	mode: "history",
	routes,
});

router.beforeEach((to, from, next) => {
	const publicPaths = [
		"/",
		"/login",
		"/evaluation/respond",
		"/sign-up",
		"/account/setup",
		"/password/forgot",
		"/password/reset",
		"/accept",
		"/leave-project",
		"/admin/leave-project",
		// "/charter/thank-you",
	];

	const publicRoutes = [
		"Survey Results",
		"CharterNeedsApproval",
		"CharterApproved"
	]

	const authRequired = !publicPaths.includes(to.path) && !publicRoutes.includes(to.name);
	const userId = store.getters.getUser != null ? store.getters.getUser.userId : null;

	if (authRequired && (!store.getters.getAuthenticated || !userId)) {
		var reason;
		if (!store.getters.getAuthenticated) {
			reason = `getAuthenticated value is ${store.getters.getAuthenticated}`;
		} else if (!userId) {
			reason = `userId value is ${userId}`;
		}

		store.dispatch(
			"log",
			`Unauthenticated user attempted to go to '${to.fullPath}'. Unauthenticated reason: ${reason}`
		);

		return next({
			path: "/login",
			query: { returnUrl: to.path },
		});
	}

	store.dispatch("log", `User routed to '${to.fullPath}'`);
	next();
});

router.afterEach((to) => {
	//console.log(store.getters.getLog);
	Vue.nextTick(() => {
		document.title = to.meta.title;
	});
});

//Global mixin
import mixin from "@/mixins/global-mixin.js";
Vue.mixin(mixin);

Vue.config.productionTip = false;
Vue.prototype.$api_url = config.apiUrl;

new Vue({
	router: router,
	store: store,
	render: (h) => h(App),
}).$mount("#app");
